import Div from "@jumbo/shared/Div/Div";
import RelatedContactsTabs from "./RelatedContactsTabs";

const ContactsTab = ({id}) => (
    <Div>
        <RelatedContactsTabs id={id}/>
    </Div>
);

export default ContactsTab;